module.exports = __webpack_public_path__ + "img/overseas-business-wechat-official-accounts_qrcode.ee2d2361.png";